import { DirectLine } from 'botframework-directlinejs';
import React, { Component } from 'react';
import ReactWebChat, { createStore, createCognitiveServicesSpeechServicesPonyfillFactory } from 'botframework-webchat';
import dispatchIncomingActivityMiddleware from './../dispatchIncomingActivityMiddleware';
import { MessageObserver } from "../customizations/message-observers/index.js";

class EinsteinChat extends Component {
  constructor(props) {
    super(props);

    this.store = createStore(
      {},
      dispatchIncomingActivityMiddleware(props.appDispatch)
    );

    this.state = {};
  }

  componentDidMount() {
    this.fetchToken();
    this.fetchSpeechPonyfill();
    this.setVoiceSpeech();
    this.setSendBox();
  }

  async setVoiceSpeech() {
    this.setState({
      selectVoice: (voices, activity) => this.voiceSelector(voices, activity.locale, 'Female')
    });
  }

  voiceSelector(voices, lang, gender) {
    let voiceObject = voices.find(voice => voice.gender.toUpperCase() === gender.toUpperCase() && voice.lang.toUpperCase() === lang.toUpperCase());

    if (!voiceObject) {
      voiceObject = voices.find(voice => voice.lang.toUpperCase() === lang.toUpperCase());
    }

    if (!voiceObject) {
      voiceObject = voices.find(voice=> voice.gender.toUpperCase() === gender.toUpperCase() && voice.lang.toUpperCase() === 'en-US');
    }

    if (!voiceObject) {
      voiceObject = voices.find(voice=> voice.lang.toUpperCase() === 'en-US');
    }

    return voiceObject;
  }

  async fetchSpeechPonyfill() {
    const speechServicesTokenRes = await fetch(process.env.REACT_APP_SPEECH, { method: 'POST' });
    const { token } = await speechServicesTokenRes.json();

    const webSpeechPonyfillFactory = await createCognitiveServicesSpeechServicesPonyfillFactory({
      credentials: {
        region: process.env.REACT_APP_SPEECH_REGION,
        authorizationToken: token
      }
    });
    
    this.setState({
      webSpeechPonyfillFactory
    });
  }

  async fetchToken() {
    const directLineTokenRes = await fetch(process.env.REACT_APP_DIRECTLINE, { method: 'POST' });
    const { token } = await directLineTokenRes.json();

    this.setState(() => ({
      directLine: new DirectLine({ token: token })
    }));

    this.state.directLine.connectionStatus$
    .subscribe(connectionStatus => {
      switch(connectionStatus) {
        case 2:
          MessageObserver.startObservers();
          break;

        default:
          break;
      }
    });
  }

  setSendBox() {
    this.store.dispatch({
      type: 'WEB_CHAT/SEND_EVENT',
      payload: {
        name: 'webchat/join',
        value: { language: window.navigator.language }
      }
    });
  }

  render() {
    const styleOptions = {
      // Chat area
      // backgroundColor: 'corBranca',
      // bubbleBackground: corBranca,
      //bubbleBorderColor: '#E6E6E6',
      //bubbleBorderRadius: borderRadius,
      //bubbleBorderStyle: 'solid',
      //bubbleBorderWidth: 1,
      // bubbleFromUserBackground: corAzulRH,
      // bubbleFromUserBorderColor: corAzulRH,
      // bubbleFromUserBorderRadius: borderRadius,
      // bubbleFromUserBorderStyle: 'solid',
      // bubbleFromUserBorderWidth: 1,
      // bubbleFromUserNubOffset: 'bottom',
      // bubbleFromUserNubSize: 0,
      // bubbleFromUserTextColor: corPreta,
      // bubbleImageHeight: 240,
      // bubbleMaxWidth: 480, // screen width = 600px
      // bubbleMinHeight: 40,
      // bubbleMinWidth: 250, // min screen width = 300px, Edge requires 372px (https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/13621468/)
      // bubbleNubOffset: 'bottom',
      // bubbleNubSize: 0,
      // bubbleTextColor: 'Black',

      // Avatar
      botAvatarImage: '/sarah-face.png',
      // botAvatarBackgroundColor: corAzulRH,
      // avatarSize: 40,
      // botAvatarInitials: '',
      // userAvatarImage: '',
      // userAvatarInitials: '',

      // Send box


      // remover a margem do input caso o hideupload == false
      hideUploadButton: true,
      
      
      //hideSendBox: true,
      // microphoneButtonColorOnDictate: '#F33',
      // sendBoxBackground: 'White',
      //sendBoxButtonColor: corAzulHIAE,
      // sendBoxButtonColorOnDisabled: '#CCC',
      //sendBoxButtonColorOnFocus: corAzulHIAE,
      // sendBoxButtonColorOnHover: corAzulHIAE,
      // sendBoxHeight: 40,
      // sendBoxMaxHeight: 200,
      // sendBoxTextColor: 'Black',
      // sendBoxBorderBottom: '',
      // sendBoxBorderLeft: '',
      // sendBoxBorderRight: '',
      // sendBoxBorderTop: 'solid 1px #E6E6E6',
      // sendBoxPlaceholderColor: '#767676',
      // sendBoxTextWrap: false,

      // // Suggested actions
      // suggestedActionBackground: 'White',
      // suggestedActionBorderRadius: 0,
      // suggestedActionImageHeight: 20,
      // suggestedActionDisabledBackground: 'White',
      // suggestedActionDisabledBorder: `solid 2px #E6E6E6`,
      // suggestedActionHeight: 40,

      // //Typing Animation
      // typingAnimationBackgroundImage: null,
      // typingAnimationDuration: 5000,
      // typingAnimationHeight: 20,
      // typingAnimationWidth: 64,

      // //Spinner Animation
      // spinnerAnimationBackgroundImage: null,
      // spinnerAnimationHeight: 16,
      // spinnerAnimationWidth: 16,
      // spinnerAnimationPaddingRight: 12,
    };

    return (
      (this.state.directLine && this.state.webSpeechPonyfillFactory) ?
        <ReactWebChat
          className={"webchat"}
          styleOptions={styleOptions}
          directLine={this.state.directLine}
          store={this.store}
          webSpeechPonyfillFactory={this.state.webSpeechPonyfillFactory}
          language={"pt-BR"}
          locale={"pt-BR"}
          selectVoice={this.state.selectVoice}
          userID={process.env.REACT_APP_USERID} />
        :
        <div>Estabelecendo comunicação com a Tina&hellip;</div>
    );
  }
}
export default EinsteinChat;